import styled from 'styled-components';

import { Breadcrumb } from '@components/breadcrumb';
import { useScopedTranslate } from '@locale/translate';

import { Header } from 'components/headers';

import { JobLabels } from './job-labels';
import locale from './locale.json';

const ColorCircleWrapper = styled.div(() => ({
  height: '1.5rem',
  width: '1.5rem',
  display: 'flex',
  alignItems: 'center',
}));

const ColoredCircle = styled.div((p) => ({
  height: '1rem',
  width: '1rem',
  backgroundColor: p.color ?? '#000000',
  borderRadius: '100%',
  margin: '0 auto',
}));

export const ColorCircle = ({ color }: { color: string }) => {
  return (
    <ColorCircleWrapper>
      <ColoredCircle color={color} />
    </ColorCircleWrapper>
  );
};

export const Labels = () => {
  const { t } = useScopedTranslate(locale);
  return (
    <>
      <Header breadcrumbs={<Breadcrumb items={[{ label: t('labels') }]} />} />
      <JobLabels />
    </>
  );
};
